import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { login } from '../utils/auth';

export default function LoginPage() {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    if (login(password)) {
      navigate('/', { replace: true });
    } else {
      setError('Incorrect password. Try again.');
      setPassword('');
    }
  };

  return (
    <div style={styles.root}>
      <div style={styles.noise} />
      <div style={styles.grid} />

      <div style={styles.inner}>
        <div style={styles.content} className="fade-up">
          <div style={styles.badge}>
            <span style={styles.dot} />
            Private · Authorized Access Only
          </div>

          <h1 style={styles.title}>
            <span style={styles.titleName}>JobHunter</span>
            <span style={styles.titleAI}> AI</span>
          </h1>

          <p style={styles.subtitle}>
            Anand Pandey — Personal Dashboard
          </p>

          <p style={styles.desc}>
            This dashboard is private. If you've been given access by{' '}
            <strong style={{ color: '#fff' }}>Anand</strong>, enter the password to continue.
          </p>

          <form onSubmit={handleSubmit} style={styles.form} className="fade-up-2">
            <input
              type="password"
              placeholder="Enter password"
              value={password}
              onChange={(e) => { setPassword(e.target.value); setError(''); }}
              style={styles.input}
              autoFocus
            />
            {error && <div style={styles.error}>{error}</div>}
            <button type="submit" style={styles.button}>
              Continue →
            </button>
          </form>

          <footer style={styles.footer} className="fade-up-3">
            Built by Anand Pandey · Powered by Claude AI
          </footer>
        </div>
      </div>
    </div>
  );
}

const styles = {
  root: {
    minHeight: '100vh',
    background: '#07080f',
    position: 'relative',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  noise: {
    position: 'fixed', inset: 0, zIndex: 0, pointerEvents: 'none',
    backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)' opacity='0.04'/%3E%3C/svg%3E")`,
    backgroundRepeat: 'repeat', backgroundSize: '128px',
  },
  grid: {
    position: 'fixed', inset: 0, zIndex: 0, pointerEvents: 'none',
    backgroundImage: `linear-gradient(#0d1020 1px, transparent 1px), linear-gradient(90deg, #0d1020 1px, transparent 1px)`,
    backgroundSize: '60px 60px',
    opacity: 0.6,
  },
  inner: {
    position: 'relative', zIndex: 1,
    width: '100%', maxWidth: 520,
    padding: '48px 24px',
    display: 'flex', flexDirection: 'column', alignItems: 'center',
  },
  content: {
    textAlign: 'center',
    width: '100%',
  },
  badge: {
    display: 'inline-flex', alignItems: 'center', gap: 6,
    background: '#0d1020', border: '1px solid #1a2040',
    color: '#5a6a90', fontSize: 10, letterSpacing: 2,
    textTransform: 'uppercase', padding: '5px 14px', borderRadius: 20,
    marginBottom: 24,
  },
  dot: {
    width: 6, height: 6, borderRadius: '50%',
    background: '#00e896', display: 'inline-block',
    animation: 'pulse 2s infinite',
    boxShadow: '0 0 8px #00e896',
  },
  title: {
    fontFamily: "'Syne', sans-serif",
    fontSize: 'clamp(42px, 8vw, 64px)',
    fontWeight: 800, lineHeight: 1, marginBottom: 16,
  },
  titleName: { color: '#ffffff' },
  titleAI: { color: '#00e896' },
  subtitle: {
    color: '#3a4a6a', fontSize: 12, letterSpacing: 1,
    textTransform: 'uppercase', marginBottom: 20,
  },
  desc: {
    color: '#5a6a90', fontSize: 14, lineHeight: 1.7,
    marginBottom: 36, maxWidth: 420, margin: '0 auto 36px',
  },
  form: {
    display: 'flex', flexDirection: 'column', gap: 12,
    width: '100%', maxWidth: 380, margin: '0 auto',
  },
  input: {
    background: '#0d0f1c',
    border: '1px solid #1a1e35',
    borderRadius: 10,
    padding: '16px 18px',
    color: '#c8d4f0',
    fontSize: 14,
    fontFamily: "'JetBrains Mono', monospace",
    outline: 'none',
    textAlign: 'center',
    letterSpacing: 2,
    transition: 'border-color 0.2s',
  },
  error: {
    color: '#ff6b6b',
    fontSize: 12,
    letterSpacing: 0.5,
  },
  button: {
    background: '#00e896',
    border: 'none',
    borderRadius: 10,
    padding: '16px',
    color: '#07080f',
    fontSize: 13,
    fontWeight: 800,
    letterSpacing: 1,
    fontFamily: "'JetBrains Mono', monospace",
    textTransform: 'uppercase',
    cursor: 'pointer',
    marginTop: 4,
    transition: 'transform 0.15s',
  },
  footer: {
    marginTop: 48,
    color: '#2a3450',
    fontSize: 11,
    letterSpacing: 1,
  },
};